import { render, staticRenderFns } from "./resultInfo.vue?vue&type=template&id=714806eb&scoped=true"
import script from "./resultInfo.vue?vue&type=script&lang=js"
export * from "./resultInfo.vue?vue&type=script&lang=js"
import style0 from "./resultInfo.vue?vue&type=style&index=0&id=714806eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714806eb",
  null
  
)

export default component.exports